import React, { useState } from 'react'
import styled from '@emotion/styled'
import { AccountHeader } from '@mobi/component-library/Account'
import { Button, InfoBox } from '@mobi/component-library/Common/V2'
import { gapY } from '@mobi/component-library/Utils/gap'
import { routes } from '@mobi/account/Areas/SignUp'
import { spacing } from '@mobi/component-library/Theme/Common'
import { useHistory } from '@mobi/account/Hooks'
import { RadioGroupItem } from '@mobi/component-library/Selection&Input'
import { FormLayout } from '../'

export type Documents = 'licence' | 'passport' | 'medicare'

type Props = { attemptNumber: number }

export const IdentityDocumentSelector = ({ attemptNumber }: Props) => {
  const [selectedMethod, setSelectedMethod] = useState<Documents | undefined>(undefined)
  const history = useHistory()

  const onMethodSelected = (method: Documents) => {
    switch (method) {
      case 'licence':
        return history.push(routes.driversLicence)
      case 'medicare':
        return history.push(routes.medicare)
      case 'passport':
        return history.push(routes.passport)
    }
  }

  return (
    <FormLayout>
      <AccountHeader
        alignItems='start'
        title='How would you like to verify your identity?'
        description='To verify your identity we require additional documentation. Please select one of the options below.'
        style={{ marginBottom: '0rem' }}
      />
      {attemptNumber > 1 && (
        <InfoBox color='red' size='sm' style={{ marginTop: spacing.sm }}>
          We weren't able to confirm your identity with the details provided. Please try again.
        </InfoBox>
      )}
      <RadioGroup>
        <RadioGroupItem
          id='id-method-drivers-licence'
          size='sm'
          iconName='DuocolorCreditCard02'
          isChecked={selectedMethod === 'licence'}
          onClick={() => setSelectedMethod('licence')}
        >
          Driver's licence
        </RadioGroupItem>
        <RadioGroupItem
          id='id-method-medicare-card'
          size='sm'
          iconName='DuocolorCertificate02'
          isChecked={selectedMethod === 'medicare'}
          onClick={() => setSelectedMethod('medicare')}
        >
          Medicare card
        </RadioGroupItem>
        <RadioGroupItem
          id='id-method-passport'
          size='sm'
          iconName='DuocolorPassport'
          isChecked={selectedMethod === 'passport'}
          onClick={() => setSelectedMethod('passport')}
        >
          Passport
        </RadioGroupItem>
      </RadioGroup>
      <Footer>
        <Button
          isFullWidth
          disabled={!selectedMethod}
          onClick={() => onMethodSelected(selectedMethod as Documents)}
        >
          Continue
        </Button>
      </Footer>
    </FormLayout>
  )
}

const RadioGroup = styled.div({ display: 'flex', flexDirection: 'column' }, gapY(spacing.smx1))

const Footer = styled.footer(gapY(spacing.sm))
